import React from 'react';
import Navbar from '../Navbar';
import Wrapper from '../Wrapper';
import TituloSeccion from '../TituloSeccion';
import SubtituloSeccion from '../SubtituloSeccion';
import Seccion from '../Seccion';
import Footer from '../Footer';
import HeadTags from '../HeadTags';
import BtnFlotanteWhatsapp from '../BtnFlotanteWhatsapp';
import ItemProductoV2 from '../ItemProductoV2';
import SkeletonProducto from '../SkeletonProducto';
import SinResultadosProductos from '../SinResultadosProductos';
import Link from '../Link';
import useHook from './useHook';
import styles from './styles.module.scss';
import { Producto } from '../../models/Producto';

type Breadcrumb = {
  label: string
  href?: string
}

type GrillaProductosSEOProps = {
  title: string
  description: string
  h1: string
  intro?: string
  path: string
  schema?: any
  breadcrumb?: Breadcrumb[]
  productosIniciales: Producto[]
  totalPagesIniciales: number
  totalResultsIniciales: number
  filtroFijo: Record<string, unknown>
}

const GrillaProductosSEO = ({
  title, description, h1, intro, path, schema, breadcrumb,
  productosIniciales, totalPagesIniciales, totalResultsIniciales, filtroFijo,
}: GrillaProductosSEOProps) => {

  const { productos, loadingMore, sentinelRef } = useHook(
    { productos: productosIniciales, totalPages: totalPagesIniciales, totalResults: totalResultsIniciales },
    filtroFijo,
  );

  return (<>

    <HeadTags
      title={title}
      description={description}
      path={path}
      schema={schema}
    />

    <Navbar/>

    <Seccion padding="40px 20px" paddingMobile="20px">
      <Wrapper>

        {breadcrumb && breadcrumb.length > 0 &&
          <nav className={styles.breadcrumb} aria-label="Breadcrumb">
            {breadcrumb.map((item, i) => (
              <span key={i}>
                {item.href ? <Link href={item.href}>{item.label}</Link> : <span>{item.label}</span>}
                {i < breadcrumb.length - 1 && <span className={styles.separador}>/</span>}
              </span>
            ))}
          </nav>
        }

        <TituloSeccion align="center">{h1}</TituloSeccion>

        {intro &&
          <>
            <br/>
            <SubtituloSeccion align="center">{intro}</SubtituloSeccion>
          </>
        }

        <br/><br/>

        {productos?.length > 0 ? <>
          <div className={styles.contenedor}>
            {productos.map(item => (
              <ItemProductoV2 data={item} key={item.id}/>
            ))}
          </div>

          <div ref={sentinelRef} className={styles.sentinel} />

          {loadingMore &&
            <div className={styles.contenedor}>
              {Array.from({ length: 4 }).map((_, i) => (
                <SkeletonProducto key={i} />
              ))}
            </div>
          }
        </>
          :
          <SinResultadosProductos hasActiveFiltros={false} onClear={() => {}} />
        }

      </Wrapper>
    </Seccion>

    <br/><br/><br/>

    <Footer/>

    <BtnFlotanteWhatsapp/>
  </>);
};

export default GrillaProductosSEO;
